import CONFIG_PROD from '../../_doc/config-prod.js'
import CONFIG_ALPHA from '../../_doc/config-alpha.js'
var host = document.location.host

if (host && (host.includes('localhost') || host.includes('alpha'))) {
	var CONFIG = CONFIG_ALPHA
} else {
	var CONFIG = CONFIG_PROD
}
export {CONFIG}



// WEBPACK FOOTER //
// ./src/config/config.js